export const cleanCoords = (coords: string[]) => {
    return coords[0].replace('POINT', '').replace('(', '')
        .replace(')', '').trim().split(' ').map(p => Number(parseFloat(p).toFixed(5)))

}